/* eslint-disable no-useless-return */
import axios from "axios";
import cheerio from "cheerio";
import Constants from "../helper/Constants";

const ImageCheck = (url) => {
  return new Promise((resolve, reject) => {
    const corsURL = `${process.env.CORS_PROXY_URL}${url}`;
    console.log(corsURL);

    axios
      .get(corsURL)
      .then((res) => {
        const { data } = res;
        const $ = cheerio.load(data);
        const imageTag = $("img");
        const post = $(".nar-root");
        const errorObj = {
          mainTitle: Constants.Image.MainErrorMessage.IMAGE_FOUND
        };

        let found;

        if (imageTag && imageTag.length > 0 && post.length === 0) {
          imageTag.each((_, ele) => {
            if (ele.attribs.src) {
              const imageURL = ele.attribs.src;
              if (
                imageURL.substring(0, 37) ===
                "https://content1.getnarrativeapp.com/"
              ) {
                const postID = imageURL.split("/")[4];
                if (postID) {
                  errorObj.subTitle =
                    Constants.Image.SecondaryErrorMessage.REPOST;
                  found = true;
                  return false;
                }
              }
            }
          });

          if (found) {
            reject(errorObj);
            return;
          }
          resolve(Constants.Image.SuccessMessage.BLOG_FOUND);
          return;
        }
        resolve(Constants.Image.SuccessMessage.BLOG_FOUND);
      })
      .catch((err) => console.log(err));
  });
};

export default ImageCheck;
